module.exports = __webpack_public_path__ + "static/media/SmartShop_7-356w.2b559d3e.webp";